import React from "react";
import { Box } from "@mui/material";
import { Stack } from "@mui/joy";
import { theme } from "styles/theme";
import { useNavigate } from "react-router-dom";
import SelectCheckbox from "components/onboarding/SelectCheckBox";
import CustomTypography from "../../../../components/common/CustomTypography";
import { useOnboardingPromotionPage } from "../../../../hooks/useOnboardingPromotionPage";
import { BottomNextButtonTmp } from "../../../../components/common/BottomNextButtonTmp";
import { usePromotionOnboardingTracking } from "../../../../hooks/usePromotionOnboardingTracking";
import {
  MktVersionTypes,
  versionToPathPrefix,
} from "../../../../components/mkt/mktVersionUtils";

interface Option {
  id: number;
  text: string;
  text_1: string;
  text_2: string;
}

// 옵션 리스트
export const goal2OptionList: Option[] = [
  {
    id: 1,
    text: "자신있고 주체적인 삶",
    text_1: "자신있고 주체적인 삶을 살아가고",
    text_2: "자신있고 주체적인 삶을 살아가는\n" + "연습을 해나갈 것입니다.",
  },
  {
    id: 2,
    text: "일상의 작은 행복을 만끽하는 삶",
    text_1: "일상의 작은 행복을 만끽하고",
    text_2: "일상의 작은 행복을 만끽하는\n" + "연습을 해나갈 것입니다.",
  },
  {
    id: 3,
    text: "사람들 속에서 편안하게 어울리는 삶",
    text_1: "사람들 속에서 편안하게 어울리고",
    text_2: "사람들 속에서 편안하게 어울리는\n" + "연습을 해나갈 것입니다.",
  },
  {
    id: 4,
    text: "하루하루를 생산적으로 보내는 삶",
    text_1: "하루하루를 생산적으로 보내고",
    text_2: "하루하루를 생산적으로 보내는\n" + "연습을 해나갈 것입니다.",
  },
  {
    id: 5,
    text: "스스로를 사랑하는 독립적인 삶",
    text_1: "스스로를 사랑하는 독립적인 삶을 살아가고",
    text_2: "스스로를 사랑하는\n연습을 해나갈 것입니다",
  },
  {
    id: 6,
    text: "평안하고 여유로운 마음을 가진 삶",
    text_1: "평안하고 여유로운 마음을 가지고",
    text_2: "평안하고 여유로운 마음을 가지는\n" + "연습을 해나갈 것입니다.",
  },
];

export default function Goal_2_MultiSelect_1_Promotion({
  version = "v4",
}: {
  version?: MktVersionTypes;
}) {
  const navigate = useNavigate();

  const pageKey = "goal_2"; // 페이지를 구분할 키 값

  const { multiSelectionIdList, updateMultiSelection, handleNext } =
    useOnboardingPromotionPage({
      pageKey,
      nextPageRoute: `/${versionToPathPrefix(version)}-onboarding/goal/3`,
    });

  const { trackMultiSelection } = usePromotionOnboardingTracking(pageKey, version);

  // 체크박스 선택/해제 로직
  const handleOptionChange = (optionId: number) => {
    updateMultiSelection(optionId);
  };

  const handleNextClick = () => {
    trackMultiSelection(multiSelectionIdList);
    handleNext();
  };

  return (
    // ➊ 내용이 버튼 뒤에 가려지지 않도록 충분한 패딩을 줍니다.
    <Stack
      spacing={5}
      sx={{ paddingBottom: "40px" }} // 하단 버튼 높이보다 넉넉하게
    >
      <CustomTypography
        variant="Subtitle"
        fontWeight={500}
        sx={{ color: theme.vars.palette.Content.Strong }}
      >
        무엇을 기대하며 디스턴싱을 찾아오셨나요?
      </CustomTypography>

      <Box sx={{ display: "flex", flexDirection: "column" }}>
        {goal2OptionList.map((option) => (
          <SelectCheckbox
            key={option.id}
            checked={multiSelectionIdList.includes(option.id)}
            onChange={() => handleOptionChange(option.id)}
            label={option.text}
          />
        ))}
      </Box>

      <BottomNextButtonTmp
        disabled={multiSelectionIdList.length === 0}
        onClick={handleNextClick}
        text={"다음"}
      />
    </Stack>
  );
}
